import { ABSENT_BOOKING, CANCELLED_BOOKING, CERTIFIED_BOOKING, TRAINEE_CERTIFIED_BOOKING, COURSE_PRIM_ACT_BUTTON_CLOSED_DUE_TO_TEACHER, CONFIRMED_BOOKING, COURSE_PRIM_ACT_BUTTON_COURSE_CANCEL_CLOSED, COURSE_PRIM_ACT_BUTTON_COURSE_SIGN_UP_CLOSED_NO_LECTURES, COURSE_PRIM_ACT_BUTTON_COURSE_SIGN_UP_CLOSED, FINISHED_BOOKING, COURSE_PRIM_ACT_BUTTON_NO_SPOTS_OPEN, RESERVE_BOOKING, ABSENT_BOOKING_DESC, CERTIFIED_BOOKING_DESC, TRAINEE_CERTIFIED_BOOKING_DESC, CANCELLED_BOOKING_DESC, TEACHER_REPORT_TYPE, ALL_TEACHERS_REPORT_TYPE, COURSE_REPORT_TYPE, ALL_COURSES_REPORT_TYPE, ALL_CERTIFICATES_REPORT_TYPE, BONUS_CERTIFICATES_REPORT_TYPE, COURSE_STATUS_NONE, COURSE_STATUS_SCHEDULED, COURSE_STATUS_INPROGRESS, COURSE_STATUS_FINISHED, COURSE_STATUS_CANCELLED, COURSE_TEACHER_ROLE, COURSE_PARTICIPANT_ROLE, TEACHER_PAID_COMP_TYPE, TEACHER_HOURS_COMP_TYPE, COURSE_INTERNAL_CATEGORY, COURSE_EXTERNAL_CATEGORY, COURSE_TRAINEE_CATEGORY, COURSE_HIGHER_EDU_CATEGORY, COURSE_OTHER_CATEGORY, COURSE_LEADERSHIP_CATEGORY, COURSE_SWE_LANG, COURSE_ENG_LANG, COURSE_DIGITAL_FORMAT, COURSE_IN_PERSON_FORMAT, COURSE_HYBRID_FORMAT, REPORT_NUM_PARTICIPANT_OPT, REPORT_NUM_CANCELLATIONS_OPT, REPORT_NUM_CERT_OPT, REPORT_NUM_COURSES_OPT, REPORT_NUM_HOURS_OPT, REPORT_PARTICIPANT_INFO_OPT, EMP_IS_WORKING, EMP_HAS_QUIT, EMP_WILL_START, SHOW_ALL, COVERING_TABLE_AVAILABLE_IN_WEEK_RANGE_OPT, COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT, EXTERNAL_CERTIFIED_BOOKING, RETROACTIVE_CERTIFIED_BOOKING, EXTERNAL_CERTIFIED_BOOKING_DESC, RETROACTIVE_CERTIFIED_BOOKING_DESC } from "../../../i18n/keyConstants";

const bookingStatusDescriptions = {
    Absent: ABSENT_BOOKING_DESC,
    Certified: CERTIFIED_BOOKING_DESC,
    TraineeCertified: TRAINEE_CERTIFIED_BOOKING_DESC,
    ExternalCertified: EXTERNAL_CERTIFIED_BOOKING_DESC,
    RetroactiveCertified: RETROACTIVE_CERTIFIED_BOOKING_DESC,
    Cancelled: CANCELLED_BOOKING_DESC
}

export const disabledCourseSignUpDescriptions = {
    noSpotsOpen: COURSE_PRIM_ACT_BUTTON_NO_SPOTS_OPEN,
    courseSignupClosed: COURSE_PRIM_ACT_BUTTON_COURSE_SIGN_UP_CLOSED,
    courseCancelClosed: COURSE_PRIM_ACT_BUTTON_COURSE_CANCEL_CLOSED,
    courseNoLectures: COURSE_PRIM_ACT_BUTTON_COURSE_SIGN_UP_CLOSED_NO_LECTURES,
    teacher: COURSE_PRIM_ACT_BUTTON_CLOSED_DUE_TO_TEACHER,
}

export const bookingStatusOptions = {
    Confirmed: {
        name: CONFIRMED_BOOKING,
        value: 0,
        description: null
    },
    Reserve: {
        name: RESERVE_BOOKING,
        value: 1,
        description: null
    },
    Cancelled: {
        name: CANCELLED_BOOKING,
        value: 2,
        description: bookingStatusDescriptions.Cancelled
    },
    Absent: {
        name: ABSENT_BOOKING,
        value: 3,
        description: bookingStatusDescriptions.Absent
    },
    Finished: {
        name: FINISHED_BOOKING,
        value: 4,
        description: null
    },
    Certified: {
        name: CERTIFIED_BOOKING,
        value: 5,
        description: bookingStatusDescriptions.Certified
    },
    TraineeCertified: {
        name: TRAINEE_CERTIFIED_BOOKING,
        value: 6,
        description: bookingStatusDescriptions.TraineeCertified
    },
    ExternalCertified: {
        name: EXTERNAL_CERTIFIED_BOOKING,
        value: 7,
        description: bookingStatusDescriptions.TraineeCertified
    },
    RetroactiveCertified: {
        name: RETROACTIVE_CERTIFIED_BOOKING,
        value: 8,
        description: bookingStatusDescriptions.TraineeCertified
    },
};

export const baseReportTypes = {
    Teacher: { name: TEACHER_REPORT_TYPE, value: 0 },
    AllTeachers: { name: ALL_TEACHERS_REPORT_TYPE, value: 1 },
    Course: { name: COURSE_REPORT_TYPE, value: 2 },
    AllCourses: { name: ALL_COURSES_REPORT_TYPE, value: 3 },
    AllCertificates: { name: ALL_CERTIFICATES_REPORT_TYPE, value: 4 },
    BonusCertificates: { name: BONUS_CERTIFICATES_REPORT_TYPE, value: 5 },
};

export const courseStatusOptions = {
    None: { name: COURSE_STATUS_NONE, value: 0 },
    Scheduled: { name: COURSE_STATUS_SCHEDULED, value: 1 },
    InProgress: { name: COURSE_STATUS_INPROGRESS, value: 2 },
    Finished: { name: COURSE_STATUS_FINISHED, value: 3 },
    Cancelled: { name: COURSE_STATUS_CANCELLED, value: 4 },
};

export const courseRoleOptions = {
    Teacher: { name: COURSE_TEACHER_ROLE, value: 0 },
    Participant: { name: COURSE_PARTICIPANT_ROLE, value: 1 },
};

export const teacherCompensationTypeOptions = {
    Paid: { name: TEACHER_PAID_COMP_TYPE, value: 0 },
    Hours: { name: TEACHER_HOURS_COMP_TYPE, value: 1 }
};

export const courseCategoryOptions = {
    Internal: { name: COURSE_INTERNAL_CATEGORY, value: 0 },
    External: { name: COURSE_EXTERNAL_CATEGORY, value: 1 },
    Trainee: { name: COURSE_TRAINEE_CATEGORY, value: 2 },
    HigherVocationalEducation: { name: COURSE_HIGHER_EDU_CATEGORY, value: 3 },
    Other: { name: COURSE_OTHER_CATEGORY, value: 4 },
    Leadership: { name: COURSE_LEADERSHIP_CATEGORY, value: 5 },
}

export const courseLanguageOptions = {
    Swedish: { name: COURSE_SWE_LANG, value: 0 },
    English: { name: COURSE_ENG_LANG, value: 1 }
}

export const courseFormatOptions = {
    Digital: { name: COURSE_DIGITAL_FORMAT, value: 0 },
    InPerson: { name: COURSE_IN_PERSON_FORMAT, value: 1 },
    Hybrid: { name: COURSE_HYBRID_FORMAT, value: 2 }
}
export const employeeStatusOptions = {
    ShowAll: {name: SHOW_ALL, value: 'showAll'},
    IsWorking: { name: EMP_IS_WORKING, value: 'isWorking' },
    HasQuit: { name: EMP_HAS_QUIT, value: 'hasQuit' },
    WillStart: { name: EMP_WILL_START, value: 'willStart' }
}
export const coveringAvailabilityOptions = {
    ShowAll: { name: SHOW_ALL, value: 'all' },
    AvailableNextFiveWeeks: { name: COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT, value: 'availableNextFiveWeeks' },
    AvailableInWeekRange: { name: COVERING_TABLE_AVAILABLE_IN_WEEK_RANGE_OPT, value: 'availableInWeekRange' }
}

export const reportCheckboxOptions = {
    NumBookings: { name: REPORT_NUM_PARTICIPANT_OPT, value: false },
    NumCancellations: { name: REPORT_NUM_CANCELLATIONS_OPT, value: false },
    NumCertifications: { name: REPORT_NUM_CERT_OPT, value: false },
    NumCourses: { name: REPORT_NUM_COURSES_OPT, value: false },
    NumHours: { name: REPORT_NUM_HOURS_OPT, value: false },
    ParticipantInfo: { name: REPORT_PARTICIPANT_INFO_OPT, value: false }
};

export const translateOptionValue = (enumValue, options) => {
    const matchingOption = options && Object.keys(options).find((opt) =>
        options[opt].value === enumValue);
    return (matchingOption && options[matchingOption]?.name) || "";
}
export const translateEmployeeStatus = (value, options) => {
    const matchingOption = options && Object.keys(options).find((opt) =>
        options[opt].value === value);
    return (matchingOption && options[matchingOption]?.name) || "";
}
export const getOptionsObjectValues = (options) =>
    Object.values(options);

export const getOptionsObjectValue = (options, value) =>
    getOptionsObjectValues(options).find((objectValue) => objectValue.value === value);

export const getOptionsObjectValuesWithLabel = (options, t) =>
    getOptionsObjectValues(options).map((objectValue) => ({ ...objectValue, label: t(objectValue.name, { ns: 'shared' }) }));

export const translateOptionLabel = (options, t) =>
    getOptionsObjectValues(options).map((objectValue) => ({ ...objectValue, label: t(objectValue.label, { ns: 'shared' }) }));
